import {Component, OnInit, ViewChild, OnChanges, OnDestroy} from '@angular/core';
import {Partner} from '../../model/partner';
import {ObjectList} from '../../model/object-list';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AutofocusDirective} from '../../autofocus.directive';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {PartnersResource} from '../../model/model-resource';

@Component({
  selector: 'app-partner-page',
  templateUrl: './partner-page.component.html',
  styleUrls: ['./partner-page.component.scss']
})
export class PartnerPageComponent implements OnInit, OnChanges, OnDestroy {

  partner: Partner;
  sellers: ObjectList<Partner>;
  sellersColumns = ['name', 'created', 'actions'];
  form: UntypedFormGroup;
  editMode = false;

  @ViewChild(AutofocusDirective) focus: AutofocusDirective;

  constructor(private partnersResource: PartnersResource,
              private builder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router) {
    this.form = this.builder.group({
      name: ['', Validators.required]
    });
  }

  editPartner() {
    this.editMode = true;
    this.focus.focus();
  }

  revertPartner() {
    this.ngOnChanges();
    if (this.partner.isNew()) {
      this.router.navigate(['/settings/partners']);
    }
  }

  savePartner() {
    const formModel = this.form.value;
    const partner = this.partner.clone();
    partner.name = formModel.name;
    this.partnersResource.save(partner).subscribe((saved) => {
      this.partner = saved;
      this.ngOnChanges();
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.has('partnerId')) {
        this.partnersResource.get(+params.get('partnerId')).subscribe(partner => {
          this.partner = partner;
          this.ngOnChanges();
        });
      } else {
        this.partner = new Partner();
        this.ngOnChanges();
      }
    });
  }

  ngOnChanges() {
    if (this.partner) {
      if (this.sellers != null) {
        this.sellers.disconnect();
        this.sellers = null;
      }
      if (!this.partner.isNew()) {
        this.sellers = new ObjectList<Partner>(
          'partnerSellers',
          this.partnersResource);
        this.sellers.setFilter('parentPartnerId', this.partner.partnerId, '=');
      }
      this.editMode = false;
      this.form.reset();
      this.form.patchValue(this.partner);
      if (this.partner.isNew()) {
        this.editMode = true;
        //this.focus.focus();
      }
    }
  }

  ngOnDestroy() {
    if (this.sellers) {
      this.sellers.disconnect();
      this.sellers = null;
    }
  }
}
